var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M3.94 5 .47 8.47 1.53 9.53 5 6.061l3.47 3.47L9.53 8.47 6.061 5l3.47-3.47L8.469.47 5 3.94 1.531.47.469 1.53z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }